import { Component, OnInit } from '@angular/core';import { Platform } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, Style } from '@capacitor/status-bar';

import { AuthenticationService, TranslateConfigService, AppInfoService } from './_services';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  isAuth = false;
  selectedLanguage: any = 'es';
  isDeprecated$;
  isObsolete$;
  obsoleteMessage$;
  storeUrl$;

  constructor(
    private platform: Platform,
    private authService: AuthenticationService,
    private router: Router,
    private translateConfigService: TranslateConfigService,
    private appInfoService: AppInfoService,
    private iab: InAppBrowser
  ) {
    this.isDeprecated$ = this.appInfoService.isDeprecated$;
    this.isObsolete$ = this.appInfoService.isObsolete$;
    this.obsoleteMessage$ = this.appInfoService.obsoleteMessage$;
    this.storeUrl$ = this.appInfoService.storeUrl$;
    this.initializeApp();
    this.loadGoogleMapsScript();
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      if (this.platform.is('hybrid')) {
        await StatusBar.setStyle({ style: Style.Default });
        await StatusBar.show();
        if (this.platform.is('android')) {
          await StatusBar.setBackgroundColor({ color: '#ff00becd' });
        }
      }
      setTimeout(async () => {
        await SplashScreen.hide();
      }, 100);
    });
  }

  loadGoogleMapsScript() {
    if (!document.getElementById('google-maps-script')) {
      const script = document.createElement('script');
      script.id = 'google-maps-script';
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  ngOnInit() {
    this.authService.authenticationState.subscribe(state => {
      this.isAuth = state;
    });

    this.selectedLanguage = this.translateConfigService.getDefaultLanguage();
    this.translateConfigService.currentLang.subscribe(lang => {
      if (lang) {
        this.selectedLanguage = lang;
      }
    });


  }

  logout() {
    console.log(this.authService.logout());
    if (this.authService.logout()) {
      this.router.navigate(['/tabs/inicio/home']);
    };
  }

  languageChanged() {
    this.translateConfigService.setLanguage(this.selectedLanguage);
  }

  openStore() {
    this.storeUrl$.pipe(take(1)).subscribe(url => {
      if (url) {
        this.iab.create(url, '_system');
      }
    });
  }




}
